import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadCategoriasDelCliente } from '../../../store/slices/configuracionesSlice';
import CategoriasConfigBody from './CategoriasConfigBody';

const CategoriasDeCliente = (props) => {
  const dispatch = useDispatch();
  const categorias = useSelector(state => state.configuraciones.categoriasDelCliente.items);
  const loading = useSelector(state => state.configuraciones.categoriasDelCliente.loading);
  const onLoad = (empresaId) => dispatch(loadCategoriasDelCliente(empresaId));
  const {
    empresaId,
    onChangeValue,
    configInicial,
    seleccionarTodos,
    deseleccionarTodos
  } = props;

  return (
    <CategoriasConfigBody
      categorias={categorias}
      empresaId={empresaId}
      loading={loading}
      onChangeValue={onChangeValue}
      onLoad={onLoad}
      configInicial={configInicial}
      seleccionarTodos={seleccionarTodos}
      deseleccionarTodos={deseleccionarTodos}
    />
  );
};

export default CategoriasDeCliente;